import React, {useEffect, useRef} from "react";
import {validAnimals, Animal, Color, validColors} from "./animals";
import {StyledCustomizer} from "./style";
import {useCommentContext} from "./context";
import {getUserName, setCookie} from "../use-cookie";


const IconCustomizer: React.FC = () => {
    const { isCustomizing, set, authorName} = useCommentContext();
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!isCustomizing) return;

        const handleClickOutside = (event: MouseEvent) => {
            if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
                set.customizingToggle();
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isCustomizing, set.isCustomizing]);

    const chooseAnimal = (animal: Animal) => {
        setCookie('spirit-animal', animal);
        set.animal(animal);
        set.customizingToggle();
        set.authorName(getUserName(animal))
        // the second time this function is run, I do see that authorName was updated with the getUserName(animal) value
        // but this is never reflected in what is rendered
        console.log(authorName)
    }

    const chooseColor = (color: Color) => {
        setCookie('spirit-color', color);
        set.color(color);
        set.customizingToggle();
    }

    return (
        <>
            <StyledCustomizer ref={containerRef} style={{visibility: isCustomizing ? 'visible' : 'hidden'}}>
                <div className="icon-grid">
                    {validAnimals.map((animalName: Animal) => (
                        <div key={animalName}>
                            <img
                                key={animalName}
                                src={`/zoo/${animalName}.webp`}
                                alt={animalName}
                                onClick={() => chooseAnimal(animalName)}
                            />
                        </div>
                    ))}
                </div>
                <div className="color-grid">
                    {validColors.map((color: Color, index) => (
                        <div
                            key={`color-${index}`}
                            style={{backgroundColor: color}}
                            onClick={() => chooseColor(color)}
                        />
                    ))}
                </div>
            </StyledCustomizer>
        </>
    );
};

export default IconCustomizer;